import http from 'hubspotter-http/clients/apiHubSpotterClient';
export function isEligibleForSupport(threadId) {
  return http.get(`conversations-routing/v1/internal/eligibility/${threadId}/support`);
}
export function relocateToSupport(threadId) {
  return http.post(`conversations-routing/v1/internal/route/${threadId}/support-inbox`);
}